import React from 'react';

import styles from './Checkbox.module.scss';

interface Props {
  isChecked: boolean;
}

const Checkbox: React.FC<Props> = ({ isChecked }) => {
  return (
    <div data-testid="checkbox" className={`${styles.Outer} ${isChecked && styles.Checked}`}>
      <i className="mm-check" />
    </div>
  );
};

export default Checkbox;
